import Head from "next/head";
import { SiteMetaData } from "../utils/constants";

function SEOForMarketingPage({ description, title, image, metaTitle }) {
	const pageTitle = title ? `${title} | ${SiteMetaData.name}` : SiteMetaData.title;
	const ogTitle = title ? `${title} | ${SiteMetaData.name}` : SiteMetaData.ogTitle;
	const metaImage = image || "https://apna.co/apna-time-icon.png";
	const metaDescription = description || SiteMetaData.description;
	const metaOgDescription = description || SiteMetaData.ogDescription;
	const metaTitleText = metaTitle || SiteMetaData.title;

	return (
		<Head>
			<title>{pageTitle}</title>
			{/* Main Data */}
			<meta name="title" content={metaTitleText} />
			<meta name="description" content={metaDescription} />
			<meta name="image" content={metaImage} />

			{/* Some Business Information */}
			<meta name="author" content="apna" />
			<meta property="place:location:latitude" content="19.1176" />
			<meta property="place:location:longitude" content="72.9060" />
			<meta property="business:contact_data:locality" content="Mumbai" />
			<meta property="business:contact_data:postal_code" content="400076" />
			<meta property="business:contact_data:country_name" content="India" />
			<meta property="business:contact_data:email" content="support@apna.co" />
			<meta property="business:contact_data:phone_number" content="7700077470" />
			<meta
				property="business:contact_data:website"
				content={SiteMetaData.siteUrl}
			/>
			<meta
				itemProp="name"
				content="apna - Find a candidate in 48 hours, Find a job in 1 day"
			/>
			<meta property="profile:username" content="apna" />
			<meta
				itemProp="description"
				content="apna - Job Search | Job Groups | Job Prepartion"
			/>

			{/* OG Data */}
			<meta name="og:title" content={ogTitle} />
			<meta name="og:description" content={metaOgDescription} />
			<meta name="og:image" content={metaImage} />
			<meta name="og:type" content="website" />
			<meta property="og:url" content={SiteMetaData.siteUrl} />
			<meta
				property="og:determiner"
				content="Post Jobs To Get Candidates | Hire Staff Easily In 48  Hours"
			/>

			{/* Twitter Data */}
			<meta name="twitter:image" content={metaImage} />
			<meta name="twitter:title" content={ogTitle} />
			<meta name="twitter:description" content={metaOgDescription} />
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:creator" content={SiteMetaData.author} />
			<meta
				name="google-site-verification"
				content="cPMXj-SYK3XoDoly4pxw8fk2j9GuCoXG5xbNi-zfMcw"
			/>
		</Head>
		// <Helmet
		// 	htmlAttributes={{
		// 		lang,
		// 	}}
		// 	title={`${title} | Apna`}
		// 	meta={[
		// 		{
		// 			name: `description`,
		// 			content: metaDescription,
		// 		},
		// 		{
		// 			name: `image`,
		// 			content: metaImage,
		// 		},
		// 		{
		// 			property: `og:title`,
		// 			content: title,
		// 		},
		// 		{
		// 			property: `og:description`,
		// 			content: metaDescription,
		// 		},
		// 		{
		// 			property: `og:image`,
		// 			content: metaImage,
		// 		},
		// 		{
		// 			property: `og:type`,
		// 			content: `website`,
		// 		},
		// 		{
		// 			property: `twitter:image`,
		// 			content: metaImage,
		// 		},
		// 		{
		// 			name: `twitter:card`,
		// 			content: `summary_large_image`,
		// 		},
		// 		{
		// 			name: `twitter:creator`,
		// 			content: site.siteMetadata.author,
		// 		},
		// 		{
		// 			name: `twitter:title`,
		// 			content: title,
		// 		},
		// 		{
		// 			name: `twitter:description`,
		// 			content: metaDescription,
		// 		},
		// 		{
		// 			name: `google-site-verification`,
		// 			content: `cPMXj-SYK3XoDoly4pxw8fk2j9GuCoXG5xbNi-zfMcw`,
		// 		},
		// 	].concat(meta)}
		// />
	);
}

export default SEOForMarketingPage;
